import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PwaService {
  private swUpdate = inject(SwUpdate);

  constructor() {
    const swUpdate = this.swUpdate;

    if (swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(
          tap((evt) => console.log('New version available:', evt)),
          filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
        )
        .subscribe((evt) => {
          console.log('New version available:', evt);
          if (confirm('A new version is available. Load it now?')) {
            this.swUpdate.activateUpdate().then(() => window.location.reload());
          }
        });

      this.swUpdate.unrecoverable.subscribe((event) => {
        console.error('Unrecoverable error with the service worker', event.reason);
        document.location.reload();
      });
    } else {
      console.log('Service worker not enabled.');
    }
  }
}
